import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '../constants';

@Injectable()
export class UploadService {

  constructor(private http: HttpClient) { }

  uploadFile(data: FormData, moduleName: string) {
    const options = {
      headers: new HttpHeaders({
        document: 'document'
      })
    };
    const url = `${Constants.apiEndPoints.upload.replace('moduleName', moduleName)}`
    return this.http
      .post(`${Constants.baseUrl}${url}`, data, options);
  }
}
